import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getToolById } from '@reducers/clampingTools';
import { updateHeaderConfig, selectNcFileData, selectNcFileId } from '@reducers/details';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { NCFileTraceabilityContent } from '@v2/pages/common/components/NCFileTraceabilityContent';
import { DETAILS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsNCFileTraceability: FC = () => {
  const dispatch = useAppDispatch();
  const ncFileData = useSelector(selectNcFileData);
  const ncFileId = useSelector(selectNcFileId);
  const title = useTitle();

  useToolDetails({
    getToolById: (id) => dispatch(getToolById(id)),
    updateHeaderConfig: (config) => dispatch(updateHeaderConfig(config)),
    getNCFileById: (id, select) => dispatch(getNCFileById(id, select)),
    getFullNCFile: true,
  });

  const anchorNcFileId = ncFileData.data?.ncFileId ?? ncFileId ?? null;

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={DETAILS_SCREENS_CONTAINER_STYLES}>
        <NCFileTraceabilityContent ncFileId={anchorNcFileId} resolving={!ncFileData.wasLoaded} />
      </View>
    </DetailsPageWrapper>
  );
};

export { ToolsDetailsNCFileTraceability };
